// Auto-generated by scripts/gen-build-version.mjs from package.json.
// DO NOT edit by hand — `npm run release -- --apply` bumps package.json
// and the next `npm run dev` / `npm run build` regenerates this file.
// iter586.

/** Display + tool version stamped into the app footer, SettingsAbout,
 *  SARIF exports, Provenance, copy-as-cURL UA, and module registry
 *  umbrella entries. Tracks `package.json#version` exactly. */
export const APP_VERSION = "0.64.0" as const;
